export const mediaTypes = {
    Program : 1,
    Experience :2,
    UserAvatar : 3,
    ProviderLogo : 4,
}